import { isLocalhost } from '@/constants/constants';
import { captureMessage, captureException } from '@sentry/browser';

export const logMessage = (message) => {
  if (isLocalhost) {
    // eslint-disable-next-line no-console
    return console.log(message);
  }
  captureMessage('Something went wrong');
};

export const logError = (error) => {
  if (isLocalhost) {
    // eslint-disable-next-line no-console
    return console.error(error);
  }
  captureException(error);
};
